import * as z from "zod";

// Best-effort prefill for the dispute-alert enrollment page: a statement
// descriptor (CDRN/ETHOCA) and recent Visa refund ARNs (RDR), both sourced from
// Shopify. Either may be empty when unreadable; the merchant edits before submit.
export const getDisputelyEnrollPrefill = {
  name: "getDisputelyEnrollPrefill" as const,
  input: z.object({}),
  output: z.object({
    descriptor: z.string().optional(),
    arns: z.array(z.string()),
  }),
};
